import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../styles/MonthlyProgressTracker.css';

const PLAN_CONFIG = [
  { key: 'blog_post', label: 'Blog Posts' },
  { key: 'social_media', label: 'Social Posts' }
];

// Shows an operator-facing summary of how many posts have been client-approved
// this month against the brand's subscription quota. Sending an idea or draft
// to the client is not progress here - only client approval counts.
const MonthlyProgressTracker = ({ brandId }) => {
  const [progress, setProgress] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!brandId) {
      setProgress(null);
      return;
    }

    let cancelled = false;
    setLoading(true);

    axios.get(`/api/brands/${brandId}/monthly-progress`, { withCredentials: true })
      .then(response => {
        if (!cancelled) setProgress(response.data);
      })
      .catch(() => {
        if (!cancelled) setProgress(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => { cancelled = true; };
  }, [brandId]);

  if (!brandId || loading || !progress) return null;

  const activePlans = PLAN_CONFIG
    .map(plan => ({ ...plan, data: progress[plan.key] }))
    .filter(plan => plan.data && plan.data.enabled && plan.data.quota > 0);

  if (activePlans.length === 0) return null;

  const monthLabel = new Date(`${progress.month}-01T00:00:00Z`).toLocaleDateString('en-US', {
    month: 'long',
    year: 'numeric',
    timeZone: 'UTC'
  });

  return (
    <div className="mpt-tracker">
      <span className="mpt-tracker-title">{monthLabel} Progress</span>
      <div className="mpt-items">
        {activePlans.map(({ key, label, data }) => {
          const pct = Math.min(100, Math.round((data.approved / data.quota) * 100));
          const metQuota = data.approved >= data.quota;
          return (
            <div className="mpt-item" key={key}>
              <div className="mpt-item-row">
                <span className="mpt-item-label">{label}</span>
                <span className={`mpt-item-count ${metQuota ? 'mpt-count-met' : ''}`}>
                  {data.approved}/{data.quota} approved
                </span>
              </div>
              <div className="mpt-bar-track">
                <div
                  className={`mpt-bar-fill ${metQuota ? 'mpt-bar-fill-met' : ''}`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              {data.in_review > 0 && (
                <span className="mpt-item-subtext">{data.in_review} awaiting client approval</span>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MonthlyProgressTracker;
